import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { TrustpilotService } from 'src/app/services/trustpilot/trustpilot.service';

@Component({
  selector: 'app-trustbox-testimonials-mobile',
  templateUrl: './trustbox-testimonials-mobile.component.html'
})

export class TrustboxTestimonialsMobileComponent implements AfterViewInit {
  @ViewChild('trustbox') private trustbox?: ElementRef<HTMLElement>;

  constructor(private trustpilotService: TrustpilotService) {}

  ngAfterViewInit(): void {
    this.trustpilotService.render(this.trustbox?.nativeElement);
  }
}
